"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeightResponseT = exports.HeightResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Returns the current min and max positional tracker heights
 */
class HeightResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsHeightResponse(bb, obj) {
        return (obj || new HeightResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsHeightResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new HeightResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    minHeight() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    maxHeight() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    static startHeightResponse(builder) {
        builder.startObject(2);
    }
    static addMinHeight(builder, minHeight) {
        builder.addFieldFloat32(0, minHeight, 0.0);
    }
    static addMaxHeight(builder, maxHeight) {
        builder.addFieldFloat32(1, maxHeight, 0.0);
    }
    static endHeightResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createHeightResponse(builder, minHeight, maxHeight) {
        HeightResponse.startHeightResponse(builder);
        HeightResponse.addMinHeight(builder, minHeight);
        HeightResponse.addMaxHeight(builder, maxHeight);
        return HeightResponse.endHeightResponse(builder);
    }
    unpack() {
        return new HeightResponseT(this.minHeight(), this.maxHeight());
    }
    unpackTo(_o) {
        _o.minHeight = this.minHeight();
        _o.maxHeight = this.maxHeight();
    }
}
exports.HeightResponse = HeightResponse;
class HeightResponseT {
    constructor(minHeight = 0.0, maxHeight = 0.0) {
        this.minHeight = minHeight;
        this.maxHeight = maxHeight;
    }
    pack(builder) {
        return HeightResponse.createHeightResponse(builder, this.minHeight, this.maxHeight);
    }
}
exports.HeightResponseT = HeightResponseT;
